export const CoreInitiativesByIdName = 'CoreInitiativesById';
